export const userModel =  {
    email: '',
    id: 0,
    firstName: '',
    lastName: ''
};